import { createContext, useEffect, useState } from 'react'

const ShoppingCartContext = createContext(1)

const ShoppingCartProvider = ({ children }) => {
  const user = JSON.parse(sessionStorage.getItem('user'))
  const permissions = JSON.parse(sessionStorage.getItem('permissions'))
  const [sessions] = useState(JSON.parse(localStorage.getItem('sessions')))
  const [carts, setCarts] = useState([])
  const [actualCart, setActualCart] = useState(0)
  const [loadingSession, setLoadingSession] = useState(false)
  const [showSessionDelete, setShowSessionDelete] = useState(false)

  useEffect(() => {
    if (sessions !== null) {
      const carts = sessions[user.id].cart
      if (!carts) {
        if (!['Admin', 'PDV', 'Supervisor'].includes(permissions['role'])) {
          addCart()
        }
      } else {
        setCarts(carts)
      }
    }
  }, [sessions])

  const createQuote = async costumer => {
    try {
      const response = await fetch(`${sessionStorage.getItem('localhost')}/api/v2/cart/quote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify(costumer)
      })

      if (!response.ok) {
        console.error('Failed to create quote:', response.statusText)
        return null
      }

      const data = await response.json()
      return data?.cart_uuid || null
    } catch (error) {
      console.error('Error creating quote:', error)
      return null
    }
  }

  const deleteQuote = async cart_uuid => {
    try {
      const request = await fetch(`${sessionStorage.getItem('localhost')}/api/v2/cart/deleteQuote`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        },
        body: JSON.stringify({
          cart_uuid: cart_uuid
        })
      })

      if (request.ok) {
        const response = await request.json()
        return true
      }

      throw new Error('')
    } catch (error) {
      return false
    }
  }

  function updateSession(removingACart = null) {
    sessions[user.id].cart = removingACart !== null ? removingACart : carts
    localStorage.setItem('sessions', JSON.stringify(sessions))
  }
  function replicateCart(customer, cart) {
    // const prev = actualCart;
    addCart(customer, cart)

    console.log('cart', cart)
    // console.log('actualCart', carts.length);
    // removeCart(cart);
  }

  async function addCart(costumer = {}, oldCart = null) {
    // Check if the user already has the maximum allowed carts (10).
    if (carts.length >= 10) return

    // Prepare customer information if provided.
    const customerData = costumer.name ? { costumer: { ...costumer } } : {}

    // If an old cart is provided, use its data to create the new cart.
    const oldCartData = oldCart
      ? {
          waybills: (oldCart.waybills || []).map(item => ({
            ...item,
            stamp: item.stamp || new Date().valueOf() + Math.random(),
            type: 'waybills'
          })),
          products: (oldCart.products || []).map(item => ({
            ...item,
            stamp: item.stamp || new Date().valueOf() + Math.random(),
            type: 'products'
          })),
          deliveries: (oldCart.deliveries || []).map(item => ({
            ...item,
            stamp: item.stamp || new Date().valueOf() + Math.random(),
            type: 'deliveries'
          })),
          pendingPays: []
        }
      : {
          waybills: [],
          products: [],
          deliveries: [],
          pendingPays: []
        }

    // Create a quote and obtain the cart_uuid.
    const cart_uuid = await createQuote(customerData)

    // If the quote creation failed, exit the function.
    if (cart_uuid === null) return

    // Add a new cart session with the obtained cart_uuid, customer data, and old carts data.
    let newCarts = [...carts, { cart_uuid: cart_uuid, ...oldCartData, ...customerData }]
    // console.log('newCarts', newCarts)
    setCarts(newCarts)
    setActualCart(newCarts.length - 1)

    updateSession(newCarts)
  }

  async function removeCart() {
    const cart = carts[actualCart]

    // Se realiza la siguiente petición con el fin de eliminar un quote.
    const isDelete = await deleteQuote(cart?.cart_uuid)
    if (!isDelete) return alert('Algo ocurrio al momento de eliminar la sesión. Intentelo más tarde y deje para despues en eliminar esta sesión.')

    // Se filtra el array y se excluye la sesión que se va a eliminar.
    const cartsFiltered = carts.filter((cart, i) => i !== actualCart)

    // Se actualiza la posición para que nos muestre la sesión correspondiente.
    setActualCart(actualCart === 0 ? 0 : actualCart - 1)

    // Se actualiza la sesión.
    updateSession(cartsFiltered)

    // Se actualiza el estado de carts.
    setCarts([...cartsFiltered])
  }

  async function removeAllCarts() {
    try {
      setCarts([])
      // setActualCart(0)
      updateSession([])
    } catch (error) {
      console.error('Error removing all carts:', error)
    }
  }

  function addItem(type, data) {
    if (carts[actualCart][type] === undefined) carts[actualCart][type] = []
    carts[actualCart][type].push({ ...data, stamp: new Date().valueOf(), type: type })
    updateSession()
    setCarts([...carts])
  }

  function updateItem(type, index, data) {
    if (carts[actualCart][type] === undefined) return
    const oldItem = carts[actualCart][type][index]
    carts[actualCart][type][index] = { ...oldItem, ...data, type: type }
    updateSession()
    setCarts([...carts])
  }

  function removeItem(type, index) {
    carts[actualCart][type] = carts[actualCart][type].filter((item, i) => i !== index)
    updateSession()
    setCarts([...carts])
  }

  function addObject(type, data) {
    carts[actualCart][type] = data
    updateSession()
    setCarts([...carts])
  }

  function removeObject(type) {
    carts[actualCart][type] = undefined
    updateSession()
    setCarts([...carts])
  }

  function reset() {
    sessions[user.id] = { cart: [] }
    localStorage.setItem('sessions', JSON.stringify(sessions))
  }

  function print() {
    console.debug(carts)
  }

  const params = {
    carts,
    setCarts,
    addCart,
    replicateCart,
    removeCart,
    removeAllCarts,
    actualCart,
    setActualCart,
    addItem,
    updateItem,
    removeItem,
    addObject,
    removeObject,
    print,
    reset,
    loadingSession,
    setLoadingSession,
    showSessionDelete,
    setShowSessionDelete
  }

  return <ShoppingCartContext.Provider value={params}>{children}</ShoppingCartContext.Provider>
}

export { ShoppingCartProvider }
export default ShoppingCartContext
